import React from 'react';

export default function Footer(){
  return (
    <footer className='footer'>
      <div className='container'>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',gap:12,flexWrap:'wrap'}}>
          <div>
            <strong>Smart Tech Solutions</strong>
            <div style={{color:'white',fontSize:13}}>CCTV • Repair • Web</div>
          </div>
          <div style={{color:'#white'}}>© {new Date().getFullYear()}</div>
        </div>
      </div>
    </footer>
  );
}
